/**
 * A random (version 4) UUID, 36 characters.
 *
 * Not `crypto.randomUUID`: browsers only offer it on a secure origin, and the
 * front is also opened over the LAN by its IP to try it on a phone, where it is
 * undefined. `getRandomValues` exists everywhere.
 *
 * @returns {string}
 */
export const uuidv4 = () => {
  const bytes = new Uint8Array(16);
  if (window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    // Only an environment without Web Crypto at all gets here; the key still
    // has to be unique per action, not unguessable.
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
